export const BASE_URL = import.meta.env.BASE_URL || "/";
